package com.milta.feature.route.domain.usecase

import com.milta.feature.route.domain.entity.RouteProofsResult
import com.milta.feature.route.domain.repository.RouteRepository

/**
 * GET /api/v1/routes/{routeId}/proofs — MIL-52, paginated proofs of one route for the web
 * dashboard's "Preuves de la tournée" (Screen B).
 */
class GetRouteProofsUseCase(private val repository: RouteRepository) {
    suspend operator fun invoke(routeId: String, search: String? = null, page: Int = 1, pageSize: Int = 20): RouteProofsResult =
        repository.getRouteProofs(routeId, search, page, pageSize)
}
